export default "__VITE_ASSET__CMCMaAJf__"